import { Component, Input, OnInit } from '@angular/core';
import { EventGuest } from '../../../../shared/models/events/guests/event-guest.model';
import GuestComponentView from './guest.component.html';

@Component({
  selector: 'event-guest',
  template: GuestComponentView,
  styles: [`
    .effective-order { font-size: 12px; font-weight: bold; padding: 2px 5px; border-radius: 5px; margin-right: 5px; }
    .group-institution { font-style: italic; margin-left: 18px; }
    .position { font-style: italic; }
    .person-name-block { margin-bottom: 2px !important; }
    .position-block { margin-top: 2px !important; margin-bottom: 2px !important; }
    .group-block { margin-top: 2px !important; margin-bottom: 2px !important; }
    .pi { margin-right: 5px !important; font-size: 1.25rem; }
    .chevron-related { font-size: 0.75rem !important; margin-right: 3px !important; }
    .related-label { font-style: italic; font-size: 0.85em; color: #888; margin-left: 4px; }
  `]
})
export class GuestComponent implements OnInit {
  @Input() guest: EventGuest;
  @Input() nameFirst: boolean = false;
  @Input() showConfirmationStatus: boolean = true;
  @Input() showPosition: boolean = true;
  @Input() showEffectivePositionOrder: boolean = true;
  @Input() showPositionGroup: boolean = true;
  @Input() showGroup: boolean = false;
  @Input() showEffectivePositionOrderBadge: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  isDelegatedRelation(): boolean {
    const option = (this.guest?.referred_option || '').toString().trim().toLowerCase();
    if (option === 'delegated' || option === 'delegate') {
      return true;
    }

    const referredIn = (this.guest?.referred_in || '').toString().trim().toLowerCase();
    return referredIn.includes('deleg');
  }

  isIndividualMode(): boolean {
    const mode = this.normalizeGuestMode(this.guest?.mode);
    return mode === 'individual';
  }

  private normalizeGuestMode(mode: unknown): string {
    let normalized = (mode || '').toString().trim().toLowerCase();

    if (normalized.startsWith("n'") && normalized.endsWith("'")) {
      normalized = normalized.slice(2, -1).trim();
    } else if (normalized.startsWith("'") && normalized.endsWith("'")) {
      normalized = normalized.slice(1, -1).trim();
    }

    return normalized;
  }
}
